export const actionTypes = {
    getConfigs: "[alerts] Get configs",
    updateConfig: "[alerts] Update config",
    preview: "[alerts] Preview",
    sendTest: "[alerts] Send test",
    getSilences: "[alerts] Get silences",
    saveSilence: "[alerts] Save silence",
    deleteSilence: "[alerts] Delete silence",
    getAlerts: "[alerts] Get alerts",
};

export const mutationTypes = {
    getConfigsStart: "[alerts] Get configs start",
    getConfigsSuccess: "[alerts] Get configs success",
    getConfigsFailure: "[alerts] Get configs failure",
    getSilencesStart: "[alerts] Get silences start",
    getSilencesSuccess: "[alerts] Get silences success",
    getSilencesFailure: "[alerts] Get silences failure",
    getAlertsStart: "[alerts] Get alerts start",
    getAlertsSuccess: "[alerts] Get alerts success",
    getAlertsFailure: "[alerts] Get alerts failure",
};

export const getterTypes = {
    getConfigs: "[alerts] Get configs",
    getStatsDays: "[alerts] Get stats days",
    getDefaultChannel: "[alerts] Get default channel",
    getSilences: "[alerts] Get silences",
    getAlerts: "[alerts] Get alerts",
    isLoadingConfigs: "[alerts] Is loading configs",
    isLoadingSilences: "[alerts] Is loading silences",
    isLoadingAlerts: "[alerts] Is loading alerts",
};
